// extracted by mini-css-extract-plugin
export var divider = "_nh-0";
export var systemMessage = "_nh-1";
export var systemMessageWrapper = "_nh-2";